'use strict';

import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init({ startEvent: "load" });

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import "./styles/style.scss";

import headerHandler from './scripts/mods/headerHandler.js';
import mobileMenu from './scripts/mods/mobileMenu.js';
import scannerHandler from './scripts/mods/scannerHandler.js';
import historyHandler from './scripts/mods/historyHandler.js';
import sliders from './scripts/mods/sliders.js';
import statisticHandler from './scripts/mods/statisticHandler.js';
import faqHandler from './scripts/mods/faqHandler.js';

document.addEventListener('DOMContentLoaded', () => {
	headerHandler();
	mobileMenu();
	scannerHandler();
	sliders();
	historyHandler();
	statisticHandler();
	faqHandler();
	Fancybox.bind('[data-fancybox]');
});

document.querySelectorAll('img').forEach((img) =>
	img.addEventListener('load', () =>
		AOS.refresh()
	)
);